import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    pruebaOido: [],
  },

  getters: {
    getPruebaOido: (state) => state.pruebaOido,
  },

  mutations: {
    SET_PRUEBA_OIDO(state, pruebaOido) {
      state.pruebaOido = pruebaOido;
    },
  },

  actions: {
    async fetchPruebaOido({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catPruebaOido')
        .then((response) => {
          commit('SET_PRUEBA_OIDO', response.data.data);
        });
    },
  },
};
